<igo-panel [title]="title" [withHeader]="withHeader">
  <div #content [@showContent]="opened">
    <ng-content></ng-content>
  </div>
</igo-panel>
